import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { KBFileEntity } from "../../pages/Crm/components/HelpDesk/components/KnowledgeBase/FileManagement/types/fileManagement.types";

interface FileManagementState {
  selectedFile: KBFileEntity | null;
  isFileDetailsOpen: boolean;
}

const initialState: FileManagementState = {
  selectedFile: null,
  isFileDetailsOpen: false,
};

const fileManagementSlice = createSlice({
  name: "fileManagement",
  initialState,
  reducers: {
    openFileDetails: (state, action: PayloadAction<KBFileEntity>) => {
      state.selectedFile = action.payload;
      state.isFileDetailsOpen = true;
    },
    closeFileDetails: (state) => {
      state.selectedFile = null;
      state.isFileDetailsOpen = false;
    },
  },
});

export const { openFileDetails, closeFileDetails } =
  fileManagementSlice.actions;

export default fileManagementSlice.reducer;
